import { Color } from '@/types'

export function getThemeFromColorLum(hex: string) {
  // Remove leading "#"
  hex = hex.replace(/^#/, '')

  // Expand shorthand (#abc → #aabbcc)
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('')
  }

  const r = parseInt(hex.slice(0, 2), 16)
  const g = parseInt(hex.slice(2, 4), 16)
  const b = parseInt(hex.slice(4, 6), 16)

  // Calculate relative luminance (WCAG)
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b

  return luminance > 128 ? 'light' : 'dark'
}

export function getColorCategoryLabel(color: Color) {
  const category = color.taxonomies?.['color-category']?.[0]?.name
  const needsUpdate = category?.toLowerCase() !== 'calce'
  const finishing = color.finishing?.slug.startsWith('calce') && needsUpdate ? 'Calce' : ''
  return [category, finishing].filter(Boolean).join(' ') || null
}
